




























import { defineComponent, ref } from "@vue/composition-api";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { AppointmentTypeKind } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import BaseButton from "@/components/BaseButton";
import AppointmentsItemView from "../AppointmentsItemView";

export default defineComponent({
  name: "AppointmentsItemRequestView",
  components: { BaseButton, AppointmentsItemView },
  props: {
    item: { type: Object as () => Appointment, required: true },
    authUserId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const processingAccept = ref(false);
    const onAcceptHandler = () => {
      if (props.item.typeKind !== AppointmentTypeKind.TOUR_GUIDE) {
        processingAccept.value = true;
        emit("accept", props.item.id, () => (processingAccept.value = false));
      } else {
        emit("accept");
      }
    };
    const onDeclineHandler = () => {
      emit("decline", props.item.id);
    };
    return {
      processingAccept,
      onAcceptHandler,
      onDeclineHandler,
    };
  },
});
